import { render, staticRenderFns } from "./studentlist.vue?vue&type=template&id=d364bd2a&scoped=true&"
import script from "./studentlist.vue?vue&type=script&lang=js&"
export * from "./studentlist.vue?vue&type=script&lang=js&"
import style0 from "./studentlist.vue?vue&type=style&index=0&id=d364bd2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d364bd2a",
  null
  
)

export default component.exports